import { Link } from 'react-router-dom';
import classnames from 'classnames';

import style from './BackButton.module.scss';
import { CommonTestAttributes } from 'chaika-test-attributes';

import BackIcon from './back.svg';

export interface BackButtonParams {
    previousUrl: string;
    onClick?(): void;
}

interface BackButtonContentProps extends BackButtonParams {}

export function BackButton({ previousUrl, onClick }: BackButtonContentProps) {
    return (
        <Link
            className={classnames([style.root])}
            to={previousUrl}
        >
            <div
                date-test={CommonTestAttributes.HeaderBackButton}
                date-testid={CommonTestAttributes.HeaderBackButton}
                className={style.backButton}
                onClick={onClick}
            >
                <div className={classnames([style.backIconWrapper])}>
                    <BackIcon />
                </div>
            </div>
        </Link>
    );
}
